import { Modal } from "../Modal";
import { ModalBody } from "../ModalBody";
import { ModalHeader } from "../ModalHeader";
import { Props } from "./ModalChargeResponsability.type";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { useEffect, useState } from "react";
import { Autocomplete, Divider, Grid, MenuItem, Select, TextField, Typography } from "@mui/material";
import { ModalFooter } from "../ModalFooter";
import '../../../assets/styles/modals.scss';
import { ChargeService } from "@/service/services/Charge.service";
import { Loading } from "@/components/common/Loading";

export const ModalChargeResponsability: React.FC<Props> = (props:any): JSX.Element => {

    const { open, closeModal, actionSelected, responsability, onListChargesResponsability, clearState, chargeSelected } = props;

    const [loading, setLoading] = useState<boolean>(false);

    const [data, setData] = useState({
        id: responsability ? responsability.id : '',
        description: responsability ? responsability.description : '',
    });

    const validateForm = (values) => {
        let errors: any = {};
        if(!values.description) errors.description = "descripcion requerido";
    
        return errors;
    }

    const onSubmit = async(values, {resetForm})  => {

        const formDataEdit = {
            description: values.description,
        }
        const formDataCreate = {
            description: values.description,
            idcharge : chargeSelected.id
        }
        setLoading(true);
        if(responsability && actionSelected=='edit'){
            await ChargeService.editChargeResponsability(responsability.id, formDataEdit)
            chargeSelected && onListChargesResponsability(chargeSelected.id);
            closeModal && closeModal();
        }else{
            await ChargeService.createChargeResponsability(formDataCreate).then((data) => {
                chargeSelected && onListChargesResponsability(chargeSelected.id);
                closeModal && closeModal();
            })
        }
        setLoading(false);
    }
   
    return(
        <>
        {loading && <Loading/>}

        <Modal open={open} handleClose={closeModal} handle size="sm">
            <ModalHeader
                text={(responsability && actionSelected=='edit') ? "Editar función" : "Agregar función"}
                className='positionElements'
                onCancel={closeModal}
                clearState={clearState}
            >
            </ModalHeader>
            <ModalBody>
                <Formik initialValues={data} enableReinitialize validate={ (values) => validateForm(values) } onSubmit={onSubmit}>
                    {({values, errors, touched, handleSubmit, handleChange, setFieldValue}) =>{
                        return(
                            <form onSubmit={handleSubmit}>
                                <Grid container >
                                    <Grid item xs={12} container alignItems="center" justifyContent="center" marginBottom='25px'>
                                        <Grid item xs={4}>
                                        <Typography variant="subtitle1" className="custom-input"><b>Descripción:</b></Typography>
                                        </Grid>
                                        <Grid item xs={8}>
                                        <TextField
                                            id="description"
                                            variant="standard"
                                            type="text" 
                                            name="description"
                                            fullWidth
                                            value={values.description}
                                            onChange={handleChange}
                                            placeholder="Descripción"
                                            error={errors.description && touched.description ? true : false}
                                        />
                                        </Grid>
                                    </Grid>

                                </Grid>
                                <Divider />
                                <ModalFooter 
                                    buttonType="submit"
                                    confirmText={(responsability && actionSelected=='edit') ? "ACTUALIZAR" : "REGISTRAR"}
                                    cancelText="CANCELAR" 
                                    onCancel={closeModal}
                                    onConfirm={handleSubmit}
                                    clearState={clearState}
                                />
                            </form>
                        )
                    }}
                </Formik>
            </ModalBody>
        </Modal>
        </>
    );
}